import { forwardRef, createElement } from 'react';

function IconWebsite(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M20.25 4c.966 0 1.75.784 1.75 1.75v12.5A1.75 1.75 0 0120.25 20H3.75A1.75 1.75 0 012 18.25V5.75C2 4.784 2.784 4 3.75 4h16.5zm.25 6h-17v8.25a.25.25 0 00.193.243l.057.007h16.5a.25.25 0 00.243-.193l.007-.057V10zm-.25-4.5H3.75a.25.25 0 00-.243.193L3.5 5.75V8.5h17V5.75a.25.25 0 00-.193-.243L20.25 5.5zM5.5 6.5v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Website = /*#__PURE__*/forwardRef(IconWebsite);

export default Website;
//# sourceMappingURL=Website.js.map
